export default {
  ACCURACY: 2 ** -16,
};
